import axios from "axios";
import { url } from "./url";

const baseURL = `${String(url).replace(/\/+$/, "")}/api/reports`;

const client = axios.create({
  baseURL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export async function fetchReportSchema() {
  const { data } = await client.get("/schema");
  return data;
}

export async function runReport(config, page = 1, pageSize = 25) {
  const { data } = await client.post(`/run?page=${page}&page_size=${pageSize}`, { config });
  return data;
}

export async function generateReportConfig(prompt) {
  const { data } = await client.post("/ai-generate", { prompt });
  return data;
}

export async function listTemplates(page = 1, pageSize = 20) {
  const { data } = await client.get(`/templates?page=${page}&page_size=${pageSize}`);
  return data;
}

export async function createTemplate(name, config) {
  const { data } = await client.post("/templates", { name, config });
  return data;
}

export async function updateTemplate(templateId, payload) {
  const { data } = await client.put(`/templates/${templateId}`, payload);
  return data;
}

export async function deleteTemplate(templateId) {
  const { data } = await client.delete(`/templates/${templateId}`);
  return data;
}

export async function exportReport(config, format = "csv") {
  const response = await client.post(
    "/export",
    { config, format },
    { responseType: "blob" }
  );
  const mime = response.headers["content-type"] || "";
  const ext = format === "excel" ? "xlsx" : "csv";
  const blob = new Blob([response.data], { type: mime });
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = `report_${Date.now()}.${ext}`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(downloadUrl);
}
